import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

const SummaryWarningBox = ({ children, ...props }) => (
  <Box
    sx={{
      bgcolor: 'error.A200',
      py: 1,
      px: 0.5,
      mx: 0.5,
      borderRadius: 2,
      '& .MuiTypography-root': {
        textAlign: 'center',
        '& a': {
          color: 'error.A800',
        },
      },
    }}
    direction="row"
    justifyContent="space-between"
    {...props}
  >
    {children}
  </Box>
);

SummaryWarningBox.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SummaryWarningBox;
